import React from "react";
import Panel from "@radarly/components/panel/fullscreen";
import { useClosePanel } from "@radarly/core/panel/use-cases";
import { PostsPanel } from "@radarly/models/panel";
import Posts from "./panel";

interface IProps {
  panel: PostsPanel;
}

const RadarlySharedPosts = ({ panel }: IProps) => {
  const onClosePanel = useClosePanel();
  return (
    <Panel>
      <Posts
        title={panel.data.title}
        clause={panel.data.clause}
        onClose={() => onClosePanel("posts")}
        dateFrom={panel.data.period.from.toString()}
        dateTo={panel.data.period.to.toString()}
        focusClause={panel.data.focusClause}
        sortBy={panel.data.sortBy}
        timezone={panel.data.timezone}
      />
    </Panel>
  );
};

export default RadarlySharedPosts;
